/**
 * Checks if an HTML string is effectively empty (e.g. "<p></p>", "<p><br></p>").
 * If so, returns an empty string "". Otherwise returns the original HTML unchanged.
 *
 * Returns "" instead of null so that PATCH requests send an explicit empty value
 * to the backend (null may be interpreted as "don't update this field").
 */
export function cleanEmptyHtml(html: string | null | undefined): string {
  if (!html) return '';

  // Strip HTML tags, then collapse whitespace and &nbsp;
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();

  return text.length === 0 ? '' : html;
}
